var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 386,
    viewBox: "0 0 87 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-189.45 132.122C-211.565 55.5456 -276.406 0.372976 -352.632 1.57717C-445.121 3.03578 -519.934 88.6696 -518.991 191.874C-518.064 295.029 -442.841 378.339 -350.17 378.339C-309.146 378.339 -270.22 363.685 -242.283 334.852C-167.608 257.817 41.5833 9.71824 41.5833 9.71824C57.6644 -8.70092 85.6772 4.00253 85.6772 29.7317V385.123",
    stroke: "url(#paint0_linear_37_285)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_285",
    x1: -518.551,
    y1: 192.807,
    x2: 85.4494,
    y2: 192.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BA6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLine);
export default __webpack_public_path__ + "static/media/left-line.35100e7801da2f19d62cc1787b3f044e.svg";
export { ForwardRef as ReactComponent };